import type {
  ReportViewConfig,
  ReportViewConfigUpsertAck,
  UpsertReportViewConfig,
} from '../models/reportViewConfig.types'
import {
  parseReportViewConfigs,
  parseReportViewConfigUpsertAck,
  serializeReportViewConfig,
} from '../models/reportViewConfig.wire'

import { appHttp, decodeDto, unwrap } from '@/shared/http'

/** Transport for the existing workspace-scoped table/chart selection persistence. */
export class ReportViewConfigApi {
  constructor(private readonly app: Pick<typeof appHttp, 'get' | 'post'> = appHttp) {}

  private config(signal?: AbortSignal) {
    return {
      ...(signal ? { signal } : {}),
      suppressGlobalErrorHandler: true,
      meta: { suppressGlobalErrorHandler: true },
    }
  }

  async list(workspaceId: number | string, signal?: AbortSignal): Promise<ReportViewConfig[]> {
    const body = unwrap(
      await this.app.get<unknown>(
        `/workspaces/${workspaceId}/get_table_view_configs`,
        this.config(signal),
      ),
    )
    return decodeDto(body, parseReportViewConfigs)
  }

  async upsert(
    input: UpsertReportViewConfig,
    signal?: AbortSignal,
  ): Promise<ReportViewConfigUpsertAck> {
    const request = decodeDto(input, serializeReportViewConfig)
    const body = unwrap(
      await this.app.post<unknown>('/upsert_table_view_config', request, this.config(signal)),
    )
    return decodeDto(body, parseReportViewConfigUpsertAck)
  }
}

export const reportViewConfigApi = new ReportViewConfigApi()
